import React, { useState, useEffect, useRef } from 'react';
import InputSearch from '../../components/common/InputSearch';
import styled, { createGlobalStyle } from 'styled-components';
import InputSelect from '../common/InputSelect';
import CaseItem from './CaseItem';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setFilters, userFilter, listCases } from '../../modules/cases';
import { deleteCases } from '../../lib/api/cases';
import { useTranslation } from 'react-i18next';
import { caseInfo, fullScreen, initializeForm } from '../../modules/case';
import Filters from '../../components/cases/Filters';
import Spinner from '../common/Spinner';
import MessageBox from '../common/MessageBox';
import {
  downloadFileList,
  setDownloadFileList,
  downloadCancel,
} from '../../lib/api/case';
import SVG from '../common/svg';

import { TabletOrDesktop } from '../../lib/responsive';
import HButton from '../common/HButton';
import QRCodeScanner from '../auth/styled/QRCodeScanner';
// import { BrowserMultiFormatReader, NotFoundException } from '@zxing/library';
// import { CSSTransition } from 'react-transition-group';
import client from '../../lib/api/client';

const AnimationStyles = createGlobalStyle`
  .success-animation-enter {
    opacity: 0;
    transform: scale(0.9);
  }
  .success-animation-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: opacity 300ms, transform 300ms;
  }
  .success-animation-exit {
    opacity: 1;
    transform: scale(1);
  }
  .success-animation-exit-active {
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 300ms, transform 300ms;
  }
`;

const MobileCaseListMainBox = styled.div`
  .CaseFilterboxContainer {
    height: 56px;
    display: grid;
    grid-template-columns: 56px 48px 48px 48px minmax(0, 1fr) max-content max-content;
    grid-template-rows: 56px;
    gap: 0;
    background-color: #ffffff;
    border-bottom: solid 1px #eeeff0;
  }

  .SearchCaseFilterboxContainer {
    height: 56px;
    display: grid;
    grid-template-columns: 20px auto 8px 89px 19px;
    grid-template-rows: 56px;
    gap: 0;
    background-color: #ffffff;
    border-bottom: solid 1px #eeeff0;
  }

  .SearchBar {
    grid-column: 2;
    grid-row: 1; 
    margin: 0px;
    align-self: center;
    justify-self: left;
    height: 40px;
    width: -webkit-fill-available;
  }

  .SearchCancel {
    grid-column: 4;
    grid-row: 1;
    margin:0px;
    align-self: center;
    justify-self: left;
    height: 40px;
  }

  .Filter_checkbox {
    grid-column: 1;
    grid-row: 1;
    margin: 0px;
    align-self: center;
    justify-self: center;
    height: 24px;
  }

  .Filter_Button {
    grid-column: 2;
    grid-row: 1;
    margin: 0px;
    align-self: center;
    justify-self: center;
    height: 24px;
  }

  .Search_Button {
    grid-column: 3;
    grid-row: 1;
    margin: 0px;
    align-self: center;
    justify-self: center;
    height: 24px;
  }

  .Refresh_Button {
    grid-column: 4;
    grid-row: 1;
    margin: 0px;
    align-self: center;
    justify-self: center;
    height: 24px;
  }

  .Delete_Button {
    grid-column: 7;
    grid-row: 1;
    margin-right: 20px;
    align-self: center;
    justify-self: right;
    height: 24px;
  }

  .Register_Button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-right: 10px;
  }

  .Combo_Sort {
    grid-column: 7;
    grid-row: 1;
    margin-right: 20px;
    align-self: center;
    justify-self: right;
  }

  .checkbox {
    display: flex;
    width: 100%;
    flex-basis: 24px;
    margin: 20px 20px;
    align-items: center; //vertical center
  }

  input[type='checkbox'] {
    background-image: url('${
      process.env.PUBLIC_URL
    }/images/settings/icon-24-checkbox-active.svg');
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 24px;
    height: 24px;
    margin: 0;
    outline: none;

    &:checked {
      background-image: url('${process.env.PUBLIC_URL}/${(props) =>
  props.theme.images}/settings/icon-24-checkbox-selected.svg');
    }
  }
`;

const CaseListMainBox = styled.div`
  width: 100%;
  height: 100%;
  border-right: solid 1px #eeeff0;

  .CaseFilterboxContainer {
    height: 50px;
    display: grid;
    grid-template-columns: 72px 49px auto 180px 130px;
    grid-template-rows: 50px;
    gap: 0;
    background-color: #ffffff;
    border-bottom: solid 1px #eeeff0;
  }

  .Icon_checkbox {
    grid-column:1;
    grid-row:4;
    margin:0px;
    align-self:start;
    justify-self:center;
  }

  .Filter_checkbox {
    grid-column: 1;
    grid-row: 1;
    margin: 0px;
    align-self:center;
    justify-self:center;
    height: 24px;
  }

  .Filter_Button {
    grid-column: 2;
    grid-row: 1;
    margin: 0px;
    align-self: center;
    justify-self: left;
    height: 24px;
  }

  .Refresh_Button {
    grid-column: 3;
    grid-row: 1;
    margin: 0px;
    align-self: center;
    justify-self: left;
    height: 24px;
  }

  .Delete_Button {
    grid-column: 4;
    grid-row: 1;
    margin-right: 20px;
    align-self: center;
    justify-self: right;
    height: 24px;
  }

  .Register_Button {
    grid-column: 5;
    grid-row: 1;
    margin-right: 20px;
    align-self: center;
    justify-self: right;
  }

  .Combo_Sort {
    grid-column: 4;
    grid-row: 1;
    margin-right: 20px;
    align-self: center;
    justify-self: right;
  }

  .CaseList_CaseListBox {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
    background: #ffff;
    border-left: solid 1px #eeeff0;
  }

  .CaseList_Pagenation {
    width: 448px;
    align-self: end;
    justify-self: end;    

    padding: 0px -6px 0px 1px;
    border-top: solid 1px #eeeff0;
    border-left: solid 1px #eeeff0;
    border-right: solid 1px #eeeff0;

//    position: fixed;
    bottom: 0;
  }
  .CaseList_NoItemBox {
    align-self: center;
    justify-self: center;    
  }

  .checkbox {
    display: flex;
    width: 100%;
    flex-basis: 24px;
    margin: 20px 20px;
    align-items: center; //vertical center
  }

  input[type='checkbox'] {
    background-image: url('${
      process.env.PUBLIC_URL
    }/images/settings/icon-24-checkbox-active.svg');
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 24px;
    height: 24px;
    margin: 0;
    outline: none;

    &:checked {
      background-image: url('${process.env.PUBLIC_URL}/${(props) =>
  props.theme.images}/settings/icon-24-checkbox-selected.svg');
    }
`;

const CaseList_CaseListBlock = styled.div`
  .myScrollbar {
    height: 627px;
    overflow-y: auto;
    //    background: #ffffff;
    background: #eeeff0;
  }

  .myScrollbar::-webkit-scrollbar {
    width: 8px;
  }

  .myScrollbar::-webkit-scrollbar-thumb {
    background-color: #c0c3c7;
    border-radius: 4px;
    background-clip: padding-box;
    border: 1px solid transparent;
  }

  .myScrollbar::-webkit-scrollbar-track {
    //    background-color: #aaaaaa;
    /* box-shadow: inset 0px 0px 5px white; */
  }
`;

const Loading = styled.div`
  width: 100%;
  height: auto;

  .loading {
    margin-top: 50%;
    text-align: center;
    width: 100%;
    font-family: Source Sans Pro;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #59646a;
  }

  .mobile_loading {
    margin-top: 50%;
    margin-bottom: 50%;
    text-align: center;
    width: 100%;
    font-family: Source Sans Pro;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #59646a;
  }
`;

const generateSystemId = (length = 52) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = 'MOB';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const CaseList = ({
  cases,
  loading,
  error,
  filters,
  filterChecking,
  page,
  del_disabled_all,
  selectedID,
  _case,
  popCount,
  prevLocRef,
  history,
  location,
  match,
}) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { form, content, odm, user } = useSelector(({ cases, caseDetail, app, user }) => ({
    form: cases.filters,
    content: caseDetail.content,
    odm: app.odm,
    user: user.user,
  }));
  const [modalFilter, setModalFilter] = useState(false);
  const [checkedInputs, setCheckedInputs] = useState([]);
  const [selectedCase, setSelectedCase] = useState('');

  const [isAllChecked, setAllChecked] = useState(false);
  const [isAnyChecked, setAnyChecked] = useState(false);
  const [isSearchChecked, setSearchChecked] = useState(false);

  const [messageTitle, setMessageTitle] = useState('');
  const [messageContent, setMessageContent] = useState('');
  const [messageVisible, setMessageVisible] = useState(false);
  const isTabletOrDesktop = TabletOrDesktop();
  const [showScanner, setShowScanner] = useState(false);

  // const [isScanning, setIsScanning] = useState(false);
  // const [showScanner, setShowScanner] = useState(false);
  // const [scanSuccess, setScanSuccess] = useState(false);
  // const [registeredUdi, setRegisteredUdi] = useState('');
  // const videoRef = useRef(null);
  // const codeReader = new BrowserMultiFormatReader();

  const handleScan = async (rawScannedUdi) => {
    if (!rawScannedUdi) return;

    const scannedUdi = rawScannedUdi.replace(/[^\x20-\x7E]+/g, '');

    // --- Step 1 : Call to RegisterProdDevice ---
    const payloadStep1 = {
      udi: scannedUdi,
      userData: user,
    };
    await client.post('/v1/camera/udi/register/', payloadStep1);

    // --- Step 2 : Call to RegisterDevice3 ---
    const payloadStep2 = {
      udi: scannedUdi,
      system_id: generateSystemId(),
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      country: user.country,
      installed_date: new Date().toISOString().slice(0, 10),
      bypass_signature: true,
    };
    await client.post('/qc/v2.5/device/register/', payloadStep2, { baseURL: '/' });
  };

  // const handleRegisterClick = () => {
  //   setScanSuccess(false);
  //   setRegisteredUdi('');
  //   setShowScanner(true);
  // };

  // const stopScanner = () => {
  //   codeReader.reset();
  //   setShowScanner(false);
  //   setIsScanning(false);
  //   setRegisteredUdi('');
  // };

  // useEffect(() => {
  //   if (showScanner && videoRef.current) {
  //     codeReader.decodeFromVideoDevice(
  //       undefined,
  //       videoRef.current,
  //       async (result, err) => {
  //         if (result && !isScanning) {
  //           setIsScanning(true); 
  //           codeReader.stopContinuousDecode(); 

  //           try {
  //             const udiText = result.getText();
  //             await handleScan(udiText); 

  //             const match = udiText.match(/\(21\)(.*)/);
  //             const serialNumber = match ? match[1] : udiText;

  //             setRegisteredUdi(serialNumber);
  //             // setScanSuccess(true); 

           
  //             setTimeout(() => {
  //               stopScanner();
  //             }, 2000);
  //           } catch (error) {
  //             stopScanner();
  //           }
  //         }
  //         if (err && !(err instanceof NotFoundException)) {
  //           stopScanner();
  //         }
  //       },
  //     );
  //   }

  //   return () => {
  //     codeReader.reset();
  //   };
  // }, [showScanner]); 

  /* select it from the list of cases if exists */
  const selectCase = (_case, cases) => {
    if (_case && _case.no && cases) {
      const sel_case = cases.filter((c) => c.no === _case.no);
      if (0 < sel_case.length) {
        setSelectedCase(sel_case[0].id);
        return true;
      }
    }
    return false;
  };

  // reload case when history back and forward
  useEffect(() => {
    if (location.pathname) {
      // const items = location.pathname.split('/');
      // const _case = { no: items[items.length - 1] };

      // dispatch(caseInfo(_case));
      if (location.state || (prevLocRef.current && prevLocRef.current.state)) {
        const filtersStr = location.state
          ? JSON.stringify(location.state.filters)
          : null;
        const prevFiltersStr = prevLocRef.current.state
          ? JSON.stringify(prevLocRef.current.state.filters)
          : null;
        if (filtersStr !== prevFiltersStr) {
          dispatch(setFilters(location.state.filters));
        }
      } 
    }

    prevLocRef.current = {
      pathname: location.pathname,
      search: location.search,
      state: location.state,
    };
  }, [popCount]);

  // cases refreshed
  useEffect(() => {
    if (!isTabletOrDesktop) {
      dispatch(initializeForm('content'));
      window.scrollTo(0, 0);
      return;
    }

    // cases exists without loading
    if (!loading && cases && cases.length > 0) {
      selectCase(_case, cases);
    }
    // cases exists after loading
    else if (cases && cases.length > 0) {
      let selectFirst = false;
      if (_case) {
        // from URL
        if (!content) {
          dispatch(caseInfo({ no: match.params.caseNo }));
          selectCase(_case, cases);
        }
        // from filter, search or refresh
        // case detail already exists
        else if (!selectCase(_case, cases)) selectFirst = true;
      }
      // no case specified
      else selectFirst = true;

      // When no case is specified, the first case is selected
      if (selectFirst) {
        setSelectedCase(cases[0].id);
        dispatch(caseInfo({ id: cases[0].id }));
        // if filter changed
        if (location.pathname === '/cases') {
          history.replace(`/cases/${cases[0].no}`, {
            filters,
            page: page.number,
          });
        }
        // if page changed
        else history.push(`/cases/${cases[0].no}`, { filters, page: page.number });
      }
    }
    // no case after loading
    else if (cases && cases.length === 0) {
    }
  }, [dispatch, cases]);

  const changeHandler = (checked, id) => {
    //    var caseNum = 0;
    var chekedNum = checkedInputs.length;

    if (checked) {
      setCheckedInputs([...checkedInputs, id]);
      chekedNum++;
    } else {
      setCheckedInputs(checkedInputs.filter((el) => el !== id));
      chekedNum--;
    }

    var resultArray = cases.filter((_case) => _case.del_enabled === true);

    setAllChecked(resultArray.length === chekedNum ? true : false);
    setAnyChecked(chekedNum > 0 ? true : false);
  };

  const onAllCardCheck = (cases, checked) => {
    var _checkInputs = [];
    if (checked) {
      cases.map(
        (_case) =>
          (_checkInputs = _case.del_enabled
            ? _checkInputs.concat(_case.id)
            : _checkInputs),
      );
      setCheckedInputs(_checkInputs);
    } else setCheckedInputs(checkedInputs.filter((el) => el === ''));

    var chekedNum = _checkInputs.length;

    setAllChecked(checked ? true : false);
    setAnyChecked(chekedNum > 0 ? true : false);
  };


  const onFilterClicked = (status) => {
    setAnyChecked(false);
    setCheckedInputs([]);
    setModalFilter(true);
    console.log(form);
    dispatch(userFilter());
  };

  const onSearchClicked = () => {
    setSearchChecked(true);
  };

  const onSearchCancelClicked = () => {
    setSearchChecked(false);
  };

  const onRefreshClicked = (status) => {
    dispatch(listCases({ filters }));
  };

  const onSortSelect = (_orderBy) => {
    filters.orderBy = _orderBy;
    dispatch(setFilters(filters));
  };

  const onMessageBoxOk = (e) => {
    onDeleteCases(e);
    setAnyChecked(false);
    setMessageVisible(false);
  };

  const onMessageBoxCancel = () => {
    setMessageVisible(false);
  };

  const onConfirmDelete = (e) => {
    setMessageVisible(true);
    setMessageTitle(t('Warning'));
    setMessageContent(t('Delete checked case(s)?'));
  };

  const onDeleteCases = async (e) => {
    console.log('>> Delete Cases');
    console.log(checkedInputs);
    e.currentTarget.src = DeleteCaseIconS;

    try {
      await deleteCases({ ids: checkedInputs });
      dispatch(listCases({ filters, page: page.number }));
    } catch (e) {
      console.log(e);
    }
  };

  const onSearchEnter = (inputText) => {
    if (inputText || (filters.searchString && !inputText)) {
      filters.searchString = inputText;
      dispatch(setFilters(filters));
      history.push('/cases', { filters });
    }
  };

  function isFiltersOn(filters) {
    if (
      filters.createDateFrom === null &&
      filters.createDateTo === null &&
      filters.person === 'All' &&
      filters.status.length === 0 &&
      filters.institution === 'All'
    )
      return false;
    else return true;
  }

  function onFilterClosed(apply) {
    if (apply) {
      try {
        localStorage.setItem('caseFilters', JSON.stringify(form));
      } catch (e) {
        console.log(e);
      }

      console.log(form);

      dispatch(setFilters(form));
      history.push('/cases', { filters: form });
    } else {
      var data = JSON.parse(localStorage.getItem('caseFilters'));
      if (data !== null) {
        if (data.createDateFrom !== null)
          data.createDateFrom = new Date(data.createDateFrom);
        if (data.createDateTo !== null) data.createDateTo = new Date(data.createDateTo);
        form.status = data.status;
        form.createDateFrom = data.createDateFrom;
        form.createDateTo = data.createDateTo;
        form.person = data.person;
        form.institution = data.institution;
      }
    }

    setModalFilter(false);
  }

  const DeleteCaseIconS =
    process.env.PUBLIC_URL + '/images/common/icon-24-delete-selected.svg';

  if (error) {
    return (
      <div>
        <p>{error.message}</p>
        <p>{error.stack}</p>
      </div>
    );
  }

  const sortString = ['Last Updated', 'Order Sent', 'Status']; 

  return (
    <>
      <AnimationStyles />
      {isTabletOrDesktop && (
        <CaseListMainBox>
          <div>
            <div className={'CaseList_CaseListBox'}>
              <div class="row" style={{ width: '100%' }}>
                <InputSearch
                  size="Medium"
                  placeholder={t('Filter by search')}
                  width="calc(100% - 40px - 2px)"
                  float="left"
                  value={filters.searchString !== '' ? filters.searchString : ''}
                  inputText={filters.searchString !== '' ? filters.searchString : ''}
                  margin="16px 20px 16px 20px"
                  onSearchEnterPress={onSearchEnter}
                />
              </div>
              <div className="CaseFilterboxContainer">
                {!del_disabled_all && (
                  <div className="Filter_checkbox" title={t('Select all cases')}>
                    <input
                      type="checkBox"
                      name="checkBoxCheckedAll"
                      checked={isAllChecked}
                      onChange={(e) => {
                        onAllCardCheck(cases, e.currentTarget.checked);
                      }}
                    />
                  </div>
                )}

                <div
                  className={'Filter_Button'}
                  onClick={onFilterClicked}
                  title={t('Display filter options')}
                >
                  <SVG
                    name="filter"
                    color={isFiltersOn(filters) ? odm.main_color : '#878D93'}
                    colorOver={odm.main_color_hover}
                    colorOut={isFiltersOn(filters) ? odm.main_color : '#878D93'}
                    colorDown={odm.main_color}
                  />
                </div>

                <div
                  className={'Refresh_Button'}
                  onClick={onRefreshClicked}
                  title={t('Refresh')}
                >
                  <SVG
                    name="refresh"
                    color="#878D93"
                    colorOver={odm.main_color_hover}
                    colorOut="#878D93"
                    colorDown={odm.main_color}
                  />
                </div>

                {!loading && cases && isAnyChecked && (
                  <div
                    className={'Delete_Button'}
                    onClick={(e) => onConfirmDelete(e)}
                    title={t('Delete selected case(s)')}
                  >
                    <SVG
                      name="delete"
                      color="#878D93"
                      colorOver={odm.main_color_hover}
                      colorOut="#878D93"
                      colorDown={odm.main_color}
                    />
                  </div>
                )}


              {!loading && cases && !isAnyChecked && (
                <div className={'Combo_Sort'}>
                  <InputSelect
                    placeholder={t('Last Updated')}
                    size="Medium"
                    width="150px"
                    height="40px"
                    items={sortString}
                    border={'none'}
                    onSelect={onSortSelect}
                    selItem={filters.orderBy}
                  />
                </div>
              )}
                {/* <div className={'Register_Button'}>
                  <HButton
                    category="Primary"
                    size="Medium"
                    text="REGISTER"
                    onClick={handleRegisterClick}
                  />
                </div> */}
              </div>
              <div />
              <CaseList_CaseListBlock>
                <div
                  className="myScrollbar"
                  style={{ height: 'calc(100vh - 74px - 50px - 49px)' }}
                >
                  {loading && (
                    <Loading>
                      <div className={'loading'}>
                        <Spinner />
                      </div>
                    </Loading>
                  )}

                  {!loading && cases && cases.length > 0 && (
                    <div>
                      {cases.map((_case) => (
                        <CaseItem
                          key={_case.id}
                          _case={_case}
                          content={content}
                          isCheckVisible={!del_disabled_all}
                          selected={selectedCase === _case.id ? true : false}
                          checked={checkedInputs.includes(_case.id) ? true : false}
                          onChange={(value, id) => {
                            changeHandler(value, _case.id);
                          }}
                          onSelectCase={() => {
                            if (selectedCase !== _case.id) {
                              if (Object.keys(downloadFileList).length !== 0) {
                                /* downloadCancel('Operation canceled by the user.'); */
                                downloadCancel.forEach((cancel, i, arr) => {
                                  cancel('Operation canceled by the user.');
                                });
                                downloadCancel.length = 0;
                                setDownloadFileList({});
                              }
                              /* dispatch(caseInfo(_case.id)); */
                              dispatch(caseInfo({ id: _case.id }));
                              dispatch(initializeForm('file3D'));
                              dispatch(initializeForm('file3DName'));
                              dispatch(initializeForm('fileCount'));
                              setSelectedCase(_case.id);
                              history.push(`/cases/${_case.no}`, {
                                filters,
                                page: page.number,
                              });
                            }
                          }}
                        />
                      ))}
                    </div>
                  )}

                  {!loading && cases && cases.length === 0 && (
                    <Loading>
                      <div className={'loading'}>
                        {t('No cases available for this status')}
                      </div>
                    </Loading>
                  )}
                </div>
              </CaseList_CaseListBlock>
            </div>
          </div>
          <div className={'CaseList_LeftSpace'}></div>
          {
            <div>
              <Filters
                visible={modalFilter}
                formData={form}
                userFilter={userFilter}
                onModalClose={onFilterClosed}
              />
            </div>
          }
          <MessageBox
            visible={messageVisible}
            type="okcancel"
            title={messageTitle}
            content={messageContent}
            onOk={onMessageBoxOk}
            onCancel={onMessageBoxCancel}
          />
        </CaseListMainBox>
      )}
      {!isTabletOrDesktop && (
        <MobileCaseListMainBox>
          <div
            className={
              isSearchChecked
                ? 'SearchCaseFilterboxContainer'
                : 'CaseFilterboxContainer'
            }
          >
            {isSearchChecked && (
              <>
                <div className="SearchBar">
                  <InputSearch
                    size="Medium"
                    placeholder={t('Filter by search')}
                    float="left"
                    value={filters.searchString !== '' ? filters.searchString : ''}
                    inputText={filters.searchString !== '' ? filters.searchString : ''}
                    onSearchEnterPress={onSearchEnter}
                  />
                </div>
                <div className="SearchCancel" onClick={onSearchCancelClicked}>
                  <HButton
                    category="Secondary"
                    size="Medium"
                    text={t('Cancel').toUpperCase()}
                  />
                </div>
              </>
            )}
            {!del_disabled_all && !isSearchChecked && (
              <div className="Filter_checkbox" title={t('Select all cases')}>
                <input
                  type="checkBox"
                  name="checkBoxCheckedAll"
                  checked={isAllChecked}
                  onChange={(e) => {
                    onAllCardCheck(cases, e.currentTarget.checked);
                  }}
                />
              </div>
            )}
            {!isSearchChecked && (
              <div
                className={'Filter_Button'}
                onClick={onFilterClicked}
                title={t('Display filter options')}
              >
                <SVG
                  name="filter"
                  color={isFiltersOn(filters) ? odm.main_color : '#878D93'}
                  colorOver={odm.main_color_hover}
                  colorOut={isFiltersOn(filters) ? odm.main_color : '#878D93'}
                  colorDown={odm.main_color}
                />
              </div>
            )}
            {!isSearchChecked && (
              <div className={'Search_Button'} onClick={onSearchClicked}>
                <SVG
                  name="search"
                  color={'#878D93'}
                  colorOver={odm.main_color_hover}
                  colorOut={'#878D93'}
                  colorDown={odm.main_color}
                />
              </div>
            )}
            {!isSearchChecked && (
              <div
                className={'Refresh_Button'}
                onClick={onRefreshClicked}
                title={t('Refresh')}
              >
                <SVG
                  name="refresh"
                  color="#878D93"
                  colorOver={odm.main_color_hover}
                  colorOut="#878D93"
                  colorDown={odm.main_color}
                />
              </div>
            )}
            {!loading && cases && isAnyChecked && !isSearchChecked && (
              <div
                className={'Delete_Button'}
                onClick={(e) => onConfirmDelete(e)}
                title={t('Delete selected case(s)')}
              >
                <SVG
                  name="delete"
                  color="#878D93"
                  colorOver={odm.main_color_hover}
                  colorOut="#878D93"
                  colorDown={odm.main_color}
                />
              </div>
            )}
            {!loading && cases && !isAnyChecked && !isSearchChecked && (
              <>
                <div className={'Register_Button'}>

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                      cursor: 'pointer',
                    }}
                    onClick={() => setShowScanner(true)}
                    title={t('Register Device')}
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{
                        fontSize: 24,
                        color: '#878D93',
                      }}
                    >
                      qr_code_scanner
                    </span>
                  </div>
                  {/* <HButton
                    category="Primary"
                    size="Medium"
                    text={t('Register Device')}
                    onClick={() => setShowScanner(true)}
                  /> */}
                </div>
                <div className={'Combo_Sort'}>
                  <InputSelect
                    placeholder={t('Last Updated')}
                    size="Medium"
                    width="150px"
                    height="40px"
                    items={sortString}
                    onSelect={onSortSelect}
                    selItem={filters.orderBy}
                  />
                </div>
              </>
            )}
          </div>

          <CaseList_CaseListBlock>
            <div className="myScrollbar" style={{ height: '100%' }}>
              {loading && (
                <Loading>
                  <div className={'mobile_loading'}>
                    <Spinner />
                  </div>
                </Loading>
              )}

              {!loading && cases && cases.length > 0 && (
                <div>
                  {cases.map((_case) => (
                    <CaseItem
                      key={_case.id}
                      _case={_case}
                      content={content}
                      isCheckVisible={!del_disabled_all}
                      selected={selectedCase === _case.id ? true : false}
                      checked={checkedInputs.includes(_case.id) ? true : false}
                      onChange={(value, id) => {
                        changeHandler(value, _case.id);
                      }}
                      onSelectCase={() => {
                        if (selectedCase !== _case.id) {
                          if (Object.keys(downloadFileList).length !== 0) {
                            downloadCancel.forEach((cancel, i, arr) => {
                              cancel('Operation canceled by the user.');
                            });
                            downloadCancel.length = 0;
                            setDownloadFileList({});
                          }
                          dispatch(caseInfo({ id: _case.id }));
                          dispatch(initializeForm('file3D'));
                          dispatch(initializeForm('file3DName'));
                          dispatch(initializeForm('fileCount'));
                          dispatch(fullScreen(false));
                          setSelectedCase(_case.id);
                          history.push(`/cases/${_case.no}`, {
                            filters,
                            page: page.number,
                          });
                        }
                      }}
                    />
                  ))}
                </div>
              )}

              {!loading && cases && cases.length === 0 && (
                <Loading>
                  <div className={'mobile_loading'}>
                    {t('No cases available for this status')}
                  </div>
                </Loading>
              )}
            </div>
          </CaseList_CaseListBlock>
          <div className={'CaseList_LeftSpace'}></div>
          {
            <div>
              <Filters
                visible={modalFilter}
                formData={form}
                userFilter={userFilter}
                onModalClose={onFilterClosed}
              />
            </div>
          }
          <MessageBox
            visible={messageVisible}
            type="okcancel"
            title={messageTitle}
            content={messageContent}
            onOk={onMessageBoxOk}
            onCancel={onMessageBoxCancel}
          />
        </MobileCaseListMainBox>
      )}

      <QRCodeScanner
        show={showScanner}
        onClose={() => setShowScanner(false)}
        user={user}
      />
    </>
  );
};

export default withRouter(CaseList);
